import React, { useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import {
  returnInputFieldLength,
} from "../../../utils/commonFunctions";
import { Comments, RadioContainer } from "../../commons";
import moment from "moment";
import { JobProgressCommentType } from "../../../redux/listing/listingTypes";
import { RadioTypes } from "../../../commonTypes/universalTypes";

const RADIO_OPTIONS: RadioTypes[] = [
  {
    id: "1",
    name: "Comment",
  },
  {
    id: "0",
    name: "Link",
  },
];

type TabsType = {
  name: string;
  label: string;
};

const tabs: TabsType[] = [
  {
    name: "All Comments",
    label: "allComments",
  },
  {
    name: "All Links",
    label: "allLink",
  },
];

type AppProps = {
  modal: boolean;
  toggleModal: () => void;
  characterLength?: number;
  data?: any;
  handlePostComment?: (data?: any) => void;
  handleSubmitLeadRecording?: (data?: any) => void;
  commentFetching?: boolean;
  commentsSuccess?: number | null;
  leadDirectoryRecordingsSuccess?: number | null;
  jobProgressCommentsList?: JobProgressCommentType[] | [];
  leadDirectoryRecordingsList?: any[] | [];
  showInputBox?: boolean;
  showDetails?: boolean;
  showClientName?: boolean;
  isAdmin?: boolean;
  showLeadCommentsModal?: boolean;
  type?: string;
  isLeadCommentListPresent?: boolean;
  jobPriority?:any;
};

const ProgressCommentsModal = ({
  modal,
  toggleModal,
  data,
  characterLength,
  handlePostComment,
  commentFetching,
  isAdmin,
  jobProgressCommentsList,
  showInputBox,
  showDetails,
  showClientName,
  showLeadCommentsModal,
  type,
  isLeadCommentListPresent,
  handleSubmitLeadRecording,
  leadDirectoryRecordingsList
}: AppProps) => {
  const [commentText, setCommentText] = useState<string>("");
  const [link, setLink] = useState("");
  const [isValid, setIsValid] = useState(true);
  const [radioValue, setRadioValue] = useState(RADIO_OPTIONS[0].id);
  const [activeTab, setActiveTab] = useState(tabs[0].label);
  let todayDate = moment(new Date()).format("YYYY-MM-DD");
  const finalDate = data?.target_end_date;
  let targetEndDate = <span>{data?.target_end_date}</span>;

  const handleTabChange = (tabs: string) => {
    setActiveTab(tabs);
  };
  const renderTabs = () => {
    const filterTabs: TabsType[] = type === "leadModule" ? tabs : [tabs[0]];
    const finalTab = filterTabs?.map((tab: TabsType) => {
      return (
        <div
          key={tab?.label}
          className="pointer mr-2"
          onClick={() => {
            handleTabChange(tab?.label);
          }}
        >
          <div
            style={{
              padding: "12px 5px 12px 5px",
              color: activeTab === tab?.label ? "#dd4433" : "",
              fontSize: "14px",
            }}
            className={`tab-header ${activeTab === tab?.label ? "active" : ""}`}
          >
            {tab?.name}
          </div>
          <div
            className={`${
              activeTab === tab?.label
                ? "active-tab-bottom-border"
                : "not-active-tab-bottom-border"
            }`}
          ></div>
        </div>
      );
    });
    return finalTab;
  };

  if (
    !isAdmin &&
    data?.job_status === "Open" &&
    moment(finalDate).isBefore(todayDate)
  ) {
    targetEndDate = (
      <span className="status-Rejected">{data?.target_end_date}</span>
    );
  } else if (isAdmin && moment(finalDate).isBefore(todayDate)) {
    targetEndDate = (
      <span className="status-Rejected">{data?.target_end_date}</span>
    );
  }

  const handleCommentTextChange = (e: any) => {
    setCommentText(e.target.value);
  };

  const handleChange = (event: any) => {
    const inputValue = event.target.value;
    setLink(inputValue);
    setIsValid(inputValue && inputValue?.trim()?.includes("http"));
  };

  const handleSubmitComment = (e: any) => {
    e.preventDefault();
    if (radioValue === "1") {
      let finalData = {
        commentText: commentText.trim(),
        id: data?._id,
      };
      handlePostComment?.(finalData);
      setCommentText("");
    } else {
      let finalData = {
        linkData: link.trim(),
        id: data?._id,
      };
      handleSubmitLeadRecording?.(finalData);
      setLink("");
    }
  };

  const renderAllComments = () => {
    const finalComments = jobProgressCommentsList?.map(
      (data: JobProgressCommentType, index: number) => {
        let finalName = !data?.first_name?.length
          ? `${data?.company_name?.slice(0, 25)}...`
          : `${data.first_name} ${data?.last_name}`;
        return (
          <Comments
            key={index}
            commenterName={finalName}
            commentTime={data?.created_at}
            commentText={data?.comment}
            image={data?.profile_pic}
          />
        );
      }
    );
    return finalComments;
  };

  const renderAllRecordings = () => {
    const finalComments = leadDirectoryRecordingsList?.map(
      (data: any, index: number) => {
        let finalName = !data?.first_name?.length
          ? `${data?.company_name?.slice(0, 25)}...`
          : `${data.first_name} ${data?.last_name}`;
        return (
          <Comments
            key={index}
            type={"recording"}
            commenterName={finalName}
            commentTime={data?.created_at}
            commentText={data?.recording_url[0]}
            image={data?.profile_pic}
          />
        );
      }
    );
    return finalComments;
  };

  const handleSetRadioValue = (data: string) => {
    setRadioValue(data);
    setActiveTab(data === "1" ? "allComments" : "allLink");
  };

  return (
    <>
      <Modal isOpen={modal} toggle={toggleModal} className="modal-styles">
        <div className="p-1">
          <ModalHeader toggle={toggleModal}>
            {showLeadCommentsModal ? "Add Comment or Link" : "Job Progress"}
          </ModalHeader>
          <ModalBody>
            <div className="row">
              {!showLeadCommentsModal ? (
                <div className="col-md-12">
                  {showClientName && <h5 className="mb-3">{data?.name}</h5>}
                  <div className="d-flex flex-row">
                    <h6 className="mb-0">{`${data?.job_type} (${data?.job_id})`}</h6>
                    {!isAdmin && data?.job_status && (
                      <span
                        className={`${
                          data?.job_status === "Open"
                            ? "status-open"
                            : "status-close"
                        }`}
                      >
                        {data?.job_status}
                      </span>
                    )}
                  </div>
                  <div className="due-date-text mt-3">
                    Target End Date: {targetEndDate}
                  </div>
                </div>
              ) : (
                ""
              )}
              {showLeadCommentsModal ? (
                <div className="col-md-12">
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <div>
                      <span>Name</span>
                      <h5 className="due-date-text mb-0">
                        {data?.company_name}
                      </h5>
                    </div>
                    <div>
                      <span>Lead assigned to</span>
                      <h5 className="due-date-text mb-0">
                        {data?.assigned_to?.first_name
                          ? data?.assigned_to?.first_name
                          : "--/--"}{" "}
                        {data?.assigned_to?.last_name}
                      </h5>
                    </div>
                    <div>
                      <span>Lead Received</span>
                      <h5 className="due-date-text mb-0">
                        {data?.lead_received_on
                          ? data?.lead_received_on
                          : "--/--"}
                      </h5>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
            {showDetails && (
              <div className="row mt-4">
                <div className="col-md-12">
                  <h6>Job Details:</h6>
                  <span>{data?.job_details}</span>
                </div>
              </div>
            )}
            {type === "leadModule" && (
              <div className="row">
                <div className="col-md-12 mt-3">
                  <label htmlFor="work" style={{ fontSize: "12px" }}>
                    Insert
                  </label>
                  <div className="mt-2">
                    <RadioContainer
                      optionsList={RADIO_OPTIONS}
                      handleSetRadioValue={handleSetRadioValue}
                      radioValue={radioValue}
                    />
                  </div>
                </div>
              </div>
            )}
            {showInputBox && (
              <>
                {radioValue === "1" ? (
                  <form>
                    <div className="form-group mt-3">
                      <label
                        htmlFor="commentBox"
                        className={commentText ? "active" : ""}
                      >
                        Leave Comment
                      </label>
                      <textarea
                        // type="text"
                        className={`form-control`}
                        name="text"
                        value={commentText}
                        placeholder="Enter Your Comments Here..."
                        autoFocus
                        onChange={(e) => handleCommentTextChange(e)}
                        maxLength={characterLength}
                        onKeyPress={(e: any) =>
                          e.key === "Enter" ? handleSubmitComment(e) : null
                        }
                        disabled={data?.job_status === "Closed"}
                      />
                      <div className="input-length text-right mt-1">
                        {returnInputFieldLength(
                          commentText.length,
                          characterLength
                        )}
                      </div>
                    </div>
                  </form>
                ) : (
                  <div className="mb-3 mt-3">
                    <label>Recording Link</label>
                    <input
                      type="text"
                      autoFocus
                      placeholder="Enter Link Here..."
                      className={`form-control`}
                      value={link}
                      onChange={handleChange}
                      style={{
                        borderColor:
                          isValid || link?.length === 0 ? "#bfcbe1" : "red",
                      }}
                    />

                    {!isValid && link?.length > 0 && (
                      <p>Please enter a valid recording link.</p>
                    )}
                  </div>
                )}
                {radioValue === "1" ? (
                  <div className="text-right">
                    <span className="pointer" onClick={toggleModal}>
                      Cancel
                    </span>
                    <Button
                      color="primary ml-3"
                      onClick={(e: any) => {
                        handleSubmitComment(e);
                      }}
                      disabled={!commentText?.trim()?.length || commentFetching}
                    >
                      {commentFetching ? "Posting..." : "Post"}
                    </Button>
                  </div>
                ) : (
                  <div className="text-right">
                    <span className="pointer" onClick={toggleModal}>
                      Cancel
                    </span>
                    <Button
                      color="primary ml-3"
                      onClick={(e: any) => {
                        handleSubmitComment(e);
                      }}
                      disabled={!link?.trim()?.length || !isValid}
                    >
                      Insert Link
                    </Button>
                  </div>
                )}
              </>
            )}
            <div className="row">
              <div className="col-md-12 pl-0">
                <div
                  style={{ borderRadius: "5px 5px 0 0", padding: "0px 15px" }}
                >
                  <div
                    className="d-flex"
                    style={{ borderBottom: "2px solid #bfcbe1" }}
                  >
                    {renderTabs()}
                  </div>
                </div>
              </div>
            </div>
          </ModalBody>
          <ModalFooter style={{ borderTop: "none" }}>
            {activeTab === "allComments" ? (
              !!jobProgressCommentsList &&
              jobProgressCommentsList?.length > 0 &&
              type != "leadModule" ? (
                <div className="w-100 comment-area">{renderAllComments()}</div>
              ) : !!jobProgressCommentsList &&
                jobProgressCommentsList?.length > 0 &&
                type === "leadModule" &&
                isLeadCommentListPresent ? (
                <div className="w-100 comment-area">{renderAllComments()}</div>
              ) : (
                <div className="w-100 text-center due-date-text">
                  No Comments!
                </div>
              )
            ) : !!leadDirectoryRecordingsList &&
              leadDirectoryRecordingsList?.length > 0 &&
              type != "leadModule" ? (
              <div className="w-100 comment-area">{renderAllRecordings()}</div>
            ) : !!leadDirectoryRecordingsList &&
              leadDirectoryRecordingsList?.length > 0 &&
              type === "leadModule" &&
              isLeadCommentListPresent ? (
              <div className="w-100 comment-area">{renderAllRecordings()}</div>
            ) : (
              <div className="w-100 text-center due-date-text">
                No recordings!
              </div>
            )}
          </ModalFooter>
        </div>
      </Modal>
    </>
  );
};

export default ProgressCommentsModal;
